import { colors } from '@alixpartners/ui-components';

import styled from 'styled-components';

export const Backdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999;
`;

export const ModalContainer = styled.div`
	background: white;
	width: 1000px;
	height: 400px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
	z-index: 1000;
`;

export const ModalHeader = styled.div`
	border-bottom: 1px solid #ccc;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 5px 15px;
	> div {
		color: ${colors.grey5};
		font-weight: 600;
	}
`;
